
<template>
<div class="col-lg-12" style="padding:20px 20px 20px 30px;">
  <div class="main-card mb-3 card">
    <div class="card-body">
      <h5 class="card-title">Progress Report<div class="sub_title" style="margin-bottom: 20px; color: #333; font-size: 13px; border: 1px solid #ccc; background: #f8f8f8; height: 30px; text-align: right; position: absolute; right: 20px; top: 10px; padding: 2px 10px;">진도관리 → Progress Report </div>
      </h5>

      <div class="col-lg-12  search_title">

      </div>
      <div class="col-lg-12  search_box">
        <table class="table_search">
          <tr>
            <th>
              클래스명
            </th>
            <td>
              <div class="input-group mb-12">
                <div class="input-group-prepend">
                  <select class="custom-select flex_center" id="inputGroupSelect01">
                    <option selected>A반</option>
                    <option value="1">B반</option>
                    <option value="2">C반</option>
                  </select>
                </div>
              </div>
            </td>
            <th>
              학생이름
            </th>
            <td>
              <div class="input-group mb-12">
                <div class="input-group-prepend">
                  <select class="custom-select flex_center" id="inputGroupSelect01">
                    <option selected>ALL</option>
                    <option value="1">김대만(kimdm22)</option>
                    <option value="2">김석수(Hiyo)</option>
                  </select>
                </div>
              </div>
            </td>
            <th>
              기간
            </th>
            <td>
              <div class="input-group mb-12">
                <div class="input-group-prepend">
                  <input type="date" /><span style="color:#333;"> ~ </span><input type="date" />
                </div>
              </div>
            </td>
            <th>
              종류
            </th>
            <td colspan="3">
              <div class="btn-group" role="group" aria-label="Basic radio toggle button group">
                <input type="radio" class="btn-check" name="btnradio" id="btnradio1" autocomplete="off" checked>
                <label class="btn btn-outline-danger" for="btnradio1" style="font-size:13px;">학습횟수</label>

                <input type="radio" class="btn-check" name="btnradio" id="btnradio2" autocomplete="off">
                <label class="btn btn-outline-danger" for="btnradio2" style="font-size:13px;">확습점수</label>


              </div>
            </td>
          </tr>

        </table>

      </div>


      <div style="text-align:right;">
        <button class="btn btn-secondary ">검색</button>
      </div>
      <div class="main-card mb-3 card">
        <div class="card-header"><i class="header-icon lnr-license icon-gradient bg-plum-plate"> </i>
          <div class="btn-actions-pane-right">
            <div role="group" class="btn-group-sm nav btn-group">
              <a data-toggle="tab" href="#tab-eg1-18" class="btn-shadow btn btn-primary show active" style="padding:10px 2px;">ALL</a>
              <a data-toggle="tab" href="#tab-eg1-0" class="btn-shadow btn btn-info show active" style="padding:10px 2px;">American</a>
              <a data-toggle="tab" href="#tab-eg1-1" class="btn-shadow btn btn-success show" style="padding:10px 2px;">WS Listen</a>
              <a data-toggle="tab" href="#tab-eg1-2" class="btn-shadow btn btn-success show" style="padding:10px 2px;">WS Shodowing</a>
              <a data-toggle="tab" href="#tab-eg1-3" class="btn-shadow btn btn-success show" style="padding:10px 2px;">WS Pretest</a>
              <a data-toggle="tab" href="#tab-eg1-4" class="btn-shadow btn btn-success show" style="padding:10px 2px;">WS Test</a>
              <a data-toggle="tab" href="#tab-eg1-5" class="btn-shadow btn btn-success show" style="padding:10px 2px;">WW Practice</a>
              <a data-toggle="tab" href="#tab-eg1-6" class="btn-shadow btn btn-success show" style="padding:10px 2px;">WW Quiz</a>
              <a data-toggle="tab" href="#tab-eg1-7" class="btn-shadow btn btn-success show" style="padding:10px 2px;">WW Pretest</a>
              <a data-toggle="tab" href="#tab-eg1-8" class="btn-shadow btn btn-success show" style="padding:10px 2px;">WW Test</a>
              <a data-toggle="tab" href="#tab-eg1-9" class="btn-shadow btn btn-warning show" style="padding:10px 2px;">SS Shodowing</a>
              <a data-toggle="tab" href="#tab-eg1-10" class="btn-shadow btn btn-warning show" style="padding:10px 2px;">SS Practice</a>
              <a data-toggle="tab" href="#tab-eg1-11" class="btn-shadow btn btn-warning show" style="padding:10px 2px;">SS Presentation</a>
              <a data-toggle="tab" href="#tab-eg1-12" class="btn-shadow btn btn-warning show" style="padding:10px 2px;">SS Test</a>
              <a data-toggle="tab" href="#tab-eg1-13" class="btn-shadow btn btn-warning show" style="padding:10px 2px;">SW Practice</a>
              <a data-toggle="tab" href="#tab-eg1-14" class="btn-shadow btn btn-warning show" style="padding:10px 2px;">SW Quiz</a>
              <a data-toggle="tab" href="#tab-eg1-15" class="btn-shadow btn btn-warning show" style="padding:10px 2px;">SW Test</a>
              <a data-toggle="tab" href="#tab-eg1-16" class="btn-shadow btn btn-danger show" style="padding:10px 2px;">D Practice</a>
              <a data-toggle="tab" href="#tab-eg1-17" class="btn-shadow btn btn-danger show" style="padding:10px 2px;">D Live</a>

            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="tab-content">
            <div class="tab-pane show active" id="tab-eg1-18" role="tabpanel">
              <p>
              <table class="table table-">
                <tbody>
                  <tr>
                    <th rowspan="2">No</th>
                    <th rowspan="2">Class</th>
                    <th rowspan="2">Id</th>
                    <th rowspan="2">Name</th>
                    <th colspan="4" style="background:#f0f0f0!important;">Word Speaking</th>
                    <th colspan="4">Word Writing</th>
                    <th colspan="4" style="background:#f0f0f0!important;">Sentence Speaking</th>
                    <th colspan="4">Sentence Writing</th>
                    <th colspan="2" style="background:#f0f0f0!important;">Dubbing</th>
                    <th rowspan="2">Point</th>
                  </tr>
                  <tr>
                    <td style="background:#f0f0f0!important;">Listen</td>
                    <td style="background:#f8f8f8!important;">Pratice</td>
                    <td style="background:#f0f0f0!important;">Pretest</td>
                    <td style="background:#f8f8f8!important;">Test</td>
                    <td style="background:#f0f0f0!important;">Listen</td>
                    <td style="background:#f8f8f8!important;">Pratice</td>
                    <td style="background:#f0f0f0!important;">Pretest</td>
                    <td style="background:#f8f8f8!important;">Test</td>
                    <td style="background:#f0f0f0!important;">Listen</td>
                    <td style="background:#f8f8f8!important;">Pratice</td>
                    <td style="background:#f0f0f0!important;">Pretest</td>
                    <td style="background:#f8f8f8!important;">Test</td>
                    <td style="background:#f0f0f0!important;">Listen</td>
                    <td style="background:#f8f8f8!important;">Pratice</td>
                    <td style="background:#f0f0f0!important;">Pretest</td>
                    <td style="background:#f8f8f8!important;">Test</td>
                    <td style="background:#f0f0f0!important;">Paactice</td>
                    <td style="background:#f8f8f8!important;">Live</td>

                  </tr>
                  <tr>
                    <td>1</td>
                    <td>ubetest</td>
                    <td>kimdm22</td>
                    <td>김대만</td>
                    <td>46</td>
                    <td>22</td>
                    <td>16</td>
                    <td>28</td>
                    <td>32</td>
                    <td>44</td>
                    <td>60</td>
                    <td>70</td>
                    <td>122</td>
                    <td>22</td>
                    <td>16</td>
                    <td>28</td>
                    <td>32</td>
                    <td>44</td>
                    <td>60</td>
                    <td>70</td>
                    <td>44</td>
                    <td>60</td>
                    <td>70</td>
                  </tr>
                </tbody>
              </table>



              </p>
            </div>


            <!-- Modal -->
            <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
              <div class="modal-dialog">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Modal title</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                  </div>
                  <div class="modal-body">
                    https://bizstudy.useschool.co.kr/report/report_detail.asp?hno=813005
                  </div>

                </div>
              </div>
            </div>


            <div class="tab-pane show" id="tab-eg1-0" role="tabpanel">
              <p><span style="background:#f0f0f0;">American School</span>
                <!-- Button trigger modal -->
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th scope="col">ID</th>
                    <th scope="col">Name</th>
                    <th scope="col">Type</th>

                    <th scope="col">Course</th>
                    <th scope="col">Grade</th>
                    <th scope="col">Step</th>
                    <th scope="col">Subject</th>
                    <th scope="col">Time</th>
                    <th scope="col">Activity</th>
                    <th scope="col">Point</th>
                    <th scope="col">Date</th>
                    <th scope="col">Detail</th>

                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>kimdm22</td>
                    <td>김대만</td>
                    <td>American School</td>
                    <td>Language</td>
                    <td>GK</td>
                    <td>GK001</td>
                    <td>Language Arts</td>
                    <td>4</td>
                    <td>KR001</td>
                    <td>50</td>
                    <td>2023-03-16</td>
                    <td><button type="button" class="btn btn-danger btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" style="font-size:13px;">
                        View 해당 미국학습보기
                      </button></td><!-- 학습관 레포트 보기로 이동 -->
                    <!-- Large modal -->
                  </tr>
                  <tr>
                    <td>kimdm22</td>
                    <td>김대만</td>
                    <td>American School</td>
                    <td>Regular</td>
                    <td>Week1</td>
                    <td>day1</td>
                    <td>Language Arts</td>
                    <td>4</td>
                    <td>KR001</td>
                    <td>50</td>
                    <td>2023-03-16</td>
                    <td><button type="button" class="btn btn-danger btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" style="font-size:13px;">
                        View 해당 미국학습보기
                      </button></td><!-- 학습관 레포트 보기로 이동 -->
                    <!-- Large modal -->
                  </tr>
                </tbody>
              </table>
              </p>
            </div>


            <div class="tab-pane show" id="tab-eg1-1" role="tabpanel">
              <p><span style="background:#f0f0f0;">Word Speaking Listen</span>
                <!-- Button trigger modal -->
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th scope="col">ID</th>
                    <th scope="col">Name</th>
                    <th scope="col">Type</th>
                    <th scope="col">Date</th>
                    <th scope="col">Activity</th>
                    <th scope="col">Title</th>
                    <th scope="col">Section</th>
                    <th scope="col">Point</th>
                    <th scope="col">Detail</th>

                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>kimdm22</td>
                    <td>김대만</td>
                    <td>Word Speaking Listen</td>
                    <td>2023-03-16</td>
                    <td>CR001</td>
                    <td>I am Billy</td>
                    <td>A</td>
                    <td>50</td>
                    <td><button type="button" class="btn btn-danger btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" style="font-size:13px;">
                        View
                      </button></td><!-- 학습관 레포트 보기로 이동 -->

                    <!-- Large modal -->


                  </tr>
                </tbody>
              </table>
              </p>
            </div>
            <div class="tab-pane show" id="tab-eg1-2" role="tabpanel">
              <p><span style="background:#f0f0f0;">Word Speaking Shodowing</span>
                <!-- Button trigger modal -->
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th scope="col">ID</th>
                    <th scope="col">Name</th>
                    <th scope="col">Type</th>
                    <th scope="col">Date</th>
                    <th scope="col">Activity</th>
                    <th scope="col">Title</th>
                    <th scope="col">Section</th>
                    <th scope="col">Point</th>
                    <th scope="col">Detail</th>

                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>kimdm22</td>
                    <td>김대만</td>
                    <td>Word Speaking Listen</td>
                    <td>2023-03-16</td>
                    <td>CR001</td>
                    <td>I am Billy</td>
                    <td>A</td>
                    <td>50</td>
                    <td><button type="button" class="btn btn-danger btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" style="font-size:13px;">
                        View
                      </button></td><!-- 학습관 레포트 보기로 이동 -->

                    <!-- Large modal -->


                  </tr>
                </tbody>
              </table>
              </p>
            </div>
            <div class="tab-pane show" id="tab-eg1-3" role="tabpanel">
              <p><span style="background:#f0f0f0;">Word Speaking Pretest</span>
                <!-- Button trigger modal -->
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th scope="col">ID</th>
                    <th scope="col">Name</th>
                    <th scope="col">Type</th>
                    <th scope="col">Date</th>
                    <th scope="col">Activity</th>
                    <th scope="col">Title</th>
                    <th scope="col">Section</th>
                    <th scope="col">Point</th>
                    <th scope="col">Detail</th>

                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>kimdm22</td>
                    <td>김대만</td>
                    <td>Word Speaking Listen</td>
                    <td>2023-03-16</td>
                    <td>CR001</td>
                    <td>I am Billy</td>
                    <td>A</td>
                    <td>50</td>
                    <td><button type="button" class="btn btn-danger btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" style="font-size:13px;">
                        View
                      </button></td><!-- 학습관 레포트 보기로 이동 -->

                    <!-- Large modal -->


                  </tr>
                </tbody>
              </table>
              </p>
            </div>
            <div class="tab-pane show" id="tab-eg1-4" role="tabpanel">
              <p><span style="background:#f0f0f0;">Word Speaking Test</span>
                <!-- Button trigger modal -->
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th scope="col">ID</th>
                    <th scope="col">Name</th>
                    <th scope="col">Type</th>
                    <th scope="col">Date</th>
                    <th scope="col">Activity</th>
                    <th scope="col">Title</th>
                    <th scope="col">Section</th>
                    <th scope="col">Point</th>
                    <th scope="col">Detail</th>

                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>kimdm22</td>
                    <td>김대만</td>
                    <td>Word Speaking Listen</td>
                    <td>2023-03-16</td>
                    <td>CR001</td>
                    <td>I am Billy</td>
                    <td>A</td>
                    <td>50</td>
                    <td><button type="button" class="btn btn-danger btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" style="font-size:13px;">
                        View
                      </button></td><!-- 학습관 레포트 보기로 이동 -->

                    <!-- Large modal -->


                  </tr>
                </tbody>
              </table>
              </p>
            </div>
            <div class="tab-pane show" id="tab-eg1-5" role="tabpanel">
              <p><span style="background:#f0f0f0;">Word Writing Practice</span>
                <!-- Button trigger modal -->
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th scope="col">ID</th>
                    <th scope="col">Name</th>
                    <th scope="col">Type</th>
                    <th scope="col">Date</th>
                    <th scope="col">Activity</th>
                    <th scope="col">Title</th>
                    <th scope="col">Section</th>
                    <th scope="col">Point</th>
                    <th scope="col">Detail</th>

                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>kimdm22</td>
                    <td>김대만</td>
                    <td>Word Speaking Listen</td>
                    <td>2023-03-16</td>
                    <td>CR001</td>
                    <td>I am Billy</td>
                    <td>A</td>
                    <td>50</td>
                    <td><button type="button" class="btn btn-danger btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" style="font-size:13px;">
                        View
                      </button></td><!-- 학습관 레포트 보기로 이동 -->

                    <!-- Large modal -->


                  </tr>
                </tbody>
              </table>
              </p>
            </div>
            <div class="tab-pane show" id="tab-eg1-6" role="tabpanel">
              <p><span style="background:#f0f0f0;">Word Writing Quiz</span>
                <!-- Button trigger modal -->
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th scope="col">ID</th>
                    <th scope="col">Name</th>
                    <th scope="col">Type</th>
                    <th scope="col">Date</th>
                    <th scope="col">Activity</th>
                    <th scope="col">Title</th>
                    <th scope="col">Section</th>
                    <th scope="col">Point</th>
                    <th scope="col">Detail</th>

                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>kimdm22</td>
                    <td>김대만</td>
                    <td>Word Speaking Listen</td>
                    <td>2023-03-16</td>
                    <td>CR001</td>
                    <td>I am Billy</td>
                    <td>A</td>
                    <td>50</td>
                    <td><button type="button" class="btn btn-danger btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" style="font-size:13px;">
                        View
                      </button></td><!-- 학습관 레포트 보기로 이동 -->

                    <!-- Large modal -->


                  </tr>
                </tbody>
              </table>
              </p>
            </div>
            <div class="tab-pane show" id="tab-eg1-7" role="tabpanel">
              <p><span style="background:#f0f0f0;">Word Writing Pretest</span>
                <!-- Button trigger modal -->
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th scope="col">ID</th>
                    <th scope="col">Name</th>
                    <th scope="col">Type</th>
                    <th scope="col">Date</th>
                    <th scope="col">Activity</th>
                    <th scope="col">Title</th>
                    <th scope="col">Section</th>
                    <th scope="col">Point</th>
                    <th scope="col">Detail</th>

                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>kimdm22</td>
                    <td>김대만</td>
                    <td>Word Speaking Listen</td>
                    <td>2023-03-16</td>
                    <td>CR001</td>
                    <td>I am Billy</td>
                    <td>A</td>
                    <td>50</td>
                    <td><button type="button" class="btn btn-danger btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" style="font-size:13px;">
                        View
                      </button></td><!-- 학습관 레포트 보기로 이동 -->

                    <!-- Large modal -->


                  </tr>
                </tbody>
              </table>
              </p>
            </div>
            <div class="tab-pane show" id="tab-eg1-8" role="tabpanel">
              <p><span style="background:#f0f0f0;">Word Writing Test</span>
                <!-- Button trigger modal -->
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th scope="col">ID</th>
                    <th scope="col">Name</th>
                    <th scope="col">Type</th>
                    <th scope="col">Date</th>
                    <th scope="col">Activity</th>
                    <th scope="col">Title</th>
                    <th scope="col">Section</th>
                    <th scope="col">Point</th>
                    <th scope="col">Detail</th>

                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>kimdm22</td>
                    <td>김대만</td>
                    <td>Word Speaking Listen</td>
                    <td>2023-03-16</td>
                    <td>CR001</td>
                    <td>I am Billy</td>
                    <td>A</td>
                    <td>50</td>
                    <td><button type="button" class="btn btn-danger btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" style="font-size:13px;">
                        View
                      </button></td><!-- 학습관 레포트 보기로 이동 -->

                    <!-- Large modal -->


                  </tr>
                </tbody>
              </table>
              </p>
            </div>
            <div class="tab-pane show" id="tab-eg1-9" role="tabpanel">
              <p><span style="background:#f0f0f0;">Sentence Speaking Shodowing</span>
                <!-- Button trigger modal -->
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th scope="col">ID</th>
                    <th scope="col">Name</th>
                    <th scope="col">Type</th>
                    <th scope="col">Date</th>
                    <th scope="col">Activity</th>
                    <th scope="col">Title</th>
                    <th scope="col">Section</th>
                    <th scope="col">Point</th>
                    <th scope="col">Detail</th>

                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>kimdm22</td>
                    <td>김대만</td>
                    <td>Word Speaking Listen</td>
                    <td>2023-03-16</td>
                    <td>CR001</td>
                    <td>I am Billy</td>
                    <td>A</td>
                    <td>50</td>
                    <td><button type="button" class="btn btn-danger btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" style="font-size:13px;">
                        View
                      </button></td><!-- 학습관 레포트 보기로 이동 -->

                    <!-- Large modal -->


                  </tr>
                </tbody>
              </table>
              </p>
            </div>
            <div class="tab-pane show" id="tab-eg1-10" role="tabpanel">
              <p><span style="background:#f0f0f0;">Sentence Speaking Practice</span>
                <!-- Button trigger modal -->
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th scope="col">ID</th>
                    <th scope="col">Name</th>
                    <th scope="col">Type</th>
                    <th scope="col">Date</th>
                    <th scope="col">Activity</th>
                    <th scope="col">Title</th>
                    <th scope="col">Section</th>
                    <th scope="col">Point</th>
                    <th scope="col">Detail</th>

                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>kimdm22</td>
                    <td>김대만</td>
                    <td>Word Speaking Listen</td>
                    <td>2023-03-16</td>
                    <td>CR001</td>
                    <td>I am Billy</td>
                    <td>A</td>
                    <td>50</td>
                    <td><button type="button" class="btn btn-danger btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" style="font-size:13px;">
                        View
                      </button></td><!-- 학습관 레포트 보기로 이동 -->

                    <!-- Large modal -->


                  </tr>
                </tbody>
              </table>
              </p>
            </div>
            <div class="tab-pane show" id="tab-eg1-11" role="tabpanel">
              <p><span style="background:#f0f0f0;">Sentence Speaking Presentation</span>
                <!-- Button trigger modal -->
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th scope="col">ID</th>
                    <th scope="col">Name</th>
                    <th scope="col">Type</th>
                    <th scope="col">Date</th>
                    <th scope="col">Activity</th>
                    <th scope="col">Title</th>
                    <th scope="col">Section</th>
                    <th scope="col">Point</th>
                    <th scope="col">Detail</th>

                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>kimdm22</td>
                    <td>김대만</td>
                    <td>Word Speaking Listen</td>
                    <td>2023-03-16</td>
                    <td>CR001</td>
                    <td>I am Billy</td>
                    <td>A</td>
                    <td>50</td>
                    <td><button type="button" class="btn btn-danger btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" style="font-size:13px;">
                        View
                      </button></td><!-- 학습관 레포트 보기로 이동 -->

                    <!-- Large modal -->


                  </tr>
                </tbody>
              </table>
              </p>
            </div>
            <div class="tab-pane show" id="tab-eg1-12" role="tabpanel">
              <p><span style="background:#f0f0f0;">Sentence Speaking Test</span>
                <!-- Button trigger modal -->
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th scope="col">ID</th>
                    <th scope="col">Name</th>
                    <th scope="col">Type</th>
                    <th scope="col">Date</th>
                    <th scope="col">Activity</th>
                    <th scope="col">Title</th>
                    <th scope="col">Section</th>
                    <th scope="col">Point</th>
                    <th scope="col">Detail</th>

                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>kimdm22</td>
                    <td>김대만</td>
                    <td>Word Speaking Listen</td>
                    <td>2023-03-16</td>
                    <td>CR001</td>
                    <td>I am Billy</td>
                    <td>A</td>
                    <td>50</td>
                    <td><button type="button" class="btn btn-danger btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" style="font-size:13px;">
                        View
                      </button></td><!-- 학습관 레포트 보기로 이동 -->

                    <!-- Large modal -->


                  </tr>
                </tbody>
              </table>
              </p>
            </div>
            <div class="tab-pane show" id="tab-eg1-13" role="tabpanel">
              <p><span style="background:#f0f0f0;">Sentence Writing Practice</span>
                <!-- Button trigger modal -->
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th scope="col">ID</th>
                    <th scope="col">Name</th>
                    <th scope="col">Type</th>
                    <th scope="col">Date</th>
                    <th scope="col">Activity</th>
                    <th scope="col">Title</th>
                    <th scope="col">Section</th>
                    <th scope="col">Point</th>
                    <th scope="col">Detail</th>

                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>kimdm22</td>
                    <td>김대만</td>
                    <td>Word Speaking Listen</td>
                    <td>2023-03-16</td>
                    <td>CR001</td>
                    <td>I am Billy</td>
                    <td>A</td>
                    <td>50</td>
                    <td><button type="button" class="btn btn-danger btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" style="font-size:13px;">
                        View
                      </button></td><!-- 학습관 레포트 보기로 이동 -->

                    <!-- Large modal -->


                  </tr>
                </tbody>
              </table>
              </p>
            </div>
            <div class="tab-pane show" id="tab-eg1-14" role="tabpanel">
              <p><span style="background:#f0f0f0;">Sentence Writing Quiz</span>
                <!-- Button trigger modal -->
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th scope="col">ID</th>
                    <th scope="col">Name</th>
                    <th scope="col">Type</th>
                    <th scope="col">Date</th>
                    <th scope="col">Activity</th>
                    <th scope="col">Title</th>
                    <th scope="col">Section</th>
                    <th scope="col">Point</th>
                    <th scope="col">Detail</th>

                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>kimdm22</td>
                    <td>김대만</td>
                    <td>Word Speaking Listen</td>
                    <td>2023-03-16</td>
                    <td>CR001</td>
                    <td>I am Billy</td>
                    <td>A</td>
                    <td>50</td>
                    <td><button type="button" class="btn btn-danger btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" style="font-size:13px;">
                        View
                      </button></td><!-- 학습관 레포트 보기로 이동 -->

                    <!-- Large modal -->


                  </tr>
                </tbody>
              </table>
              </p>
            </div>
            <div class="tab-pane show" id="tab-eg1-15" role="tabpanel">
              <p><span style="background:#f0f0f0;">Sentence Writing Test</span>
                <!-- Button trigger modal -->
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th scope="col">ID</th>
                    <th scope="col">Name</th>
                    <th scope="col">Type</th>
                    <th scope="col">Date</th>
                    <th scope="col">Activity</th>
                    <th scope="col">Title</th>
                    <th scope="col">Section</th>
                    <th scope="col">Point</th>
                    <th scope="col">Detail</th>

                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>kimdm22</td>
                    <td>김대만</td>
                    <td>Word Speaking Listen</td>
                    <td>2023-03-16</td>
                    <td>CR001</td>
                    <td>I am Billy</td>
                    <td>A</td>
                    <td>50</td>
                    <td><button type="button" class="btn btn-danger btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" style="font-size:13px;">
                        View
                      </button></td><!-- 학습관 레포트 보기로 이동 -->

                    <!-- Large modal -->


                  </tr>
                </tbody>
              </table>
              </p>
            </div>
            <div class="tab-pane show" id="tab-eg1-16" role="tabpanel">
              <p><span style="background:#f0f0f0;">Dubbing Practice</span>
                <!-- Button trigger modal -->
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th scope="col">ID</th>
                    <th scope="col">Name</th>
                    <th scope="col">Type</th>
                    <th scope="col">Date</th>
                    <th scope="col">Activity</th>
                    <th scope="col">Title</th>
                    <th scope="col">Section</th>
                    <th scope="col">Point</th>
                    <th scope="col">Detail</th>

                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>kimdm22</td>
                    <td>김대만</td>
                    <td>Word Speaking Listen</td>
                    <td>2023-03-16</td>
                    <td>CR001</td>
                    <td>I am Billy</td>
                    <td>A</td>
                    <td>50</td>
                    <td><button type="button" class="btn btn-danger btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" style="font-size:13px;">
                        View
                      </button></td><!-- 학습관 레포트 보기로 이동 -->

                    <!-- Large modal -->


                  </tr>
                </tbody>
              </table>
              </p>
            </div>
            <div class="tab-pane show" id="tab-eg1-17" role="tabpanel">
              <p><span style="background:#f0f0f0;">Dubbing Live</span>
                <!-- Button trigger modal -->
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th scope="col">ID</th>
                    <th scope="col">Name</th>
                    <th scope="col">Type</th>
                    <th scope="col">Date</th>
                    <th scope="col">Activity</th>
                    <th scope="col">Title</th>
                    <th scope="col">Section</th>
                    <th scope="col">Point</th>
                    <th scope="col">Detail</th>

                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>kimdm22</td>
                    <td>김대만</td>
                    <td>Word Speaking Listen</td>
                    <td>2023-03-16</td>
                    <td>CR001</td>
                    <td>I am Billy</td>
                    <td>A</td>
                    <td>50</td>
                    <td><button type="button" class="btn btn-danger btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" style="font-size:13px;">
                        View
                      </button></td><!-- 학습관 레포트 보기로 이동 -->

                    <!-- Large modal -->


                  </tr>
                </tbody>
              </table>
              </p>
            </div>
            <div class="tab-pane show" id="tab-eg1-18" role="tabpanel">
              <p><span style="background:#f0f0f0;">Dubbing Live</span>
                <!-- Button trigger modal -->
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th scope="col">ID</th>
                    <th scope="col">Name</th>
                    <th scope="col">Type</th>
                    <th scope="col">Date</th>
                    <th scope="col">Activity</th>
                    <th scope="col">Title</th>
                    <th scope="col">Section</th>
                    <th scope="col">Point</th>
                    <th scope="col">Detail</th>

                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>kimdm22</td>
                    <td>김대만</td>
                    <td>Word Speaking Listen</td>
                    <td>2023-03-16</td>
                    <td>CR001</td>
                    <td>I am Billy</td>
                    <td>A</td>
                    <td>50</td>
                    <td><button type="button" class="btn btn-danger btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" style="font-size:13px;">
                        View
                      </button></td><!-- 학습관 레포트 보기로 이동 -->

                    <!-- Large modal -->


                  </tr>
                </tbody>
              </table>
              </p>
            </div>
          </div>
        </div>

      </div>

      <div class="flex_center">



      </div>
      <table class="table table-hover">
        <thead>
          <tr>
            <th scope="col"><input type="checkbox" disabled checked></th>
            <th scope="col">#</th>
            <th scope="col">Cl11ass</th>
            <th scope="col">Name</th>
            <th scope="col">ID</th>
            <th scope="col">Grade</th>
            <th scope="col">FAME</th>
            <th scope="col">ALPHA</th>
            <th scope="col">CARAT</th>
            <th scope="col">Detail</th>

          </tr>
        </thead>
        <tbody>
          <tr v-for="record in records" v-bind:key="record.id">
            <td><input type="checkbox"></td>
            <th scope="row">{{ record.id }}</th>
            <td>{{record.business}}</td>
            <td>{{ record.name }}</td>
            <td>{{ record.username }}</td>
            <td>{{ record.sProduct.level }}</td>
            <td>{{ record.t_fame }}</td>
            <td>{{ record.t_beta }}</td>
            <td>{{ record.t_carat }}</td>

            <td> <button class="btn btn-danger btn-sm" style="display:none;" data-bs-toggle="modal" data-bs-target=".bd-example-modal-detail">REPORT</button></td><!-- 학습관 레포트 보기로 이동 -->

            <!-- Large modal -->


          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
</template>
